import { useMutation } from '@tanstack/react-query';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';
import { CodelistRecord, CodelistRecordKey } from '../domain/codelistRecordSchema';

export type SearchRecordsResponse = {
	records: (CodelistRecord & { originalEntryId: string })[];
};

export type SearchRecordsFilter = {
	key: CodelistRecordKey;
	value: string;
};

export const useSearchRecordsMutation = (params: { projectId: string }) => {
	return useMutation({
		mutationFn: (args: { filters: SearchRecordsFilter[] }) =>
			makeRequest<SearchRecordsResponse>({
				method: 'searchRecords',
				service: 'cde',
				data: {
					projectId: params.projectId,
					filters: args.filters
				}
			})
	});
};
